// extracted by mini-css-extract-plugin
export var equalColumn = "_im-0";